import { computed, ref } from "vue"
import { useI18n } from "vue-i18n"
import { UseRootStore } from "@/model/RootStore"
import { Unit } from "@/graphql"

export function useUnitPreference() {
	const store = UseRootStore()
	const { t } = useI18n()
	const unitDraft = ref(Unit.Imperial)
	const savedUnit = ref(Unit.Imperial)
	const currentUserDetails = computed(() => store.CurrentUserBasicDetails ?? store.CurrentUserDetails)
	const unitOptions = computed(() => [
		{ id: Unit.Imperial, label: t("settingsPage.areaUnit.sqft") },
		{ id: Unit.Metric, label: t("settingsPage.areaUnit.sqm") },
	])
	const hasUnitPendingChanges = computed(() => unitDraft.value !== savedUnit.value)

	const syncUnitFromProfile = () => {
		const unit = currentUserDetails.value?.unit ?? Unit.Imperial
		unitDraft.value = unit
		savedUnit.value = unit
	}

	const saveUnitPreference = async () => {
		if (!hasUnitPendingChanges.value) {
			return
		}

		await store.saveUnit(unitDraft.value)
		savedUnit.value = unitDraft.value
	}

	return {
		unitDraft,
		unitOptions,
		syncUnitFromProfile,
		saveUnitPreference,
	}
}
